import { useEffect, useRef, useState } from "react";
import { FormInputSectionComponent } from "../../Components/FormInputSectionComponent/FormInputSectionComponent";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
import { data, DataForSpecificAcccounts } from "./BulkNotifications.config";
import { replaceUnderscore } from "../../../CommonFunction/common";
import "../../Components/FormComponents/FormComponent.scss";
import { checkFormErrors } from "../../custom_hooks/useCheckFormError";
import { ErrorToast, SuccessToast } from "../../Components/ToastComponent/RectHotToast";
import { useModalContext } from "../../Components/Reactportal/ModalContext";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useRecoilState } from "recoil";
import { AtomstateCallback } from "../../Components/VirtualTable/Tablefunctions";
async function sendBulkNotification(data, Closeformfunction, setLoading) {
  const url = `${process.env.REACT_APP_CUSTOMER_SITE_BACKEND}/sendBulkNotification`;
  setLoading(true);
  try {
    const response = await fetch(url, {
      method: "POST", // Assuming POST is the method required by the API
      headers: {
        "Content-Type": "application/json",
        //   Include any additional headers like authentication tokens if required
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      ErrorToast("Network response was not ok: " + response.statusText);
    }
    console.log(response);
    const result = response;
    console.log(result);
    SuccessToast("Notification sent successfully:", result);
    Closeformfunction();
    return result; // Process the response data as needed
  } catch (error) {
    console.log(error);
    ErrorToast("There was a problem with the fetch operation:", error);
    // You might want to handle the error differently
  } finally {
    setLoading(false); // Set loading to false when the operation is complete
  }
}
const BulkNotifications = ({ Modal_Key, ParentPortalCloseFunction, show }) => {
  console.log(Modal_Key);
  const { pushModal, popModal } = useModalContext();
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const [toggle, setToggle] = useState(show);
  const formRef = useRef({});
  const location = useLocation();
  const [config, setConfig] = useState(Modal_Key === "EMT_Accounts_Notification" ? DataForSpecificAcccounts : data);
  const [FormData, setFormdata] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);

 
  const Form_Key = "Bulk_Notifications";
  const TypeOfPortal = "Add";
  const tab = useSelector((store) => store.UniqueTabReducer?.Emt_Accounts);

  const [filters, setFilters] = useRecoilState(AtomstateCallback(tab ? "Emt_AccountsEMT_" + tab : "Emt_AccountsEMT_"));

  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    setToggle(false);
  };

  const Validate_handleSubmit = (submit) => {
    const Error = checkFormErrors(formErrors);
    if (!Error) {
      submit();
    }
  };
  const handleErrorsChange = (newErrors) => {
    setFormErrors((currentErrors) => ({
      ...currentErrors,
      ...newErrors,
    }));
  };
  const HanldeChangeonForm = (values) => {
    // console.log(values, "Formdata_without_redux1");
    setFormdata((prev) => ({
      ...prev,
      ...values,
    }));
  };
  const submit = async () => {
    // try {

    await sendBulkNotification(
      {
        ...FormData,
        ...(Modal_Key === "EMT_Accounts_Notification" ? { filters: filters } : {}),
      },
      Closeformfunction,
      setLoading
    );

    // Handle successful sending here (e.g., clear form, show success message)
    // } catch (error) {
    //   ErrorToast("Failed to send notification:", error);
    // Handle errors here (e.g., show error message to user)
    // }
  };
  const SaveAndClose = () => {
    submit("Close");
  };

  useEffect(() => {
    pushModal(Form_Key);
    return () => {
      popModal(Form_Key);
    };
  }, []);

  return (
    <>
      <div key={Modal_Key} className="LinkSaleMainDiv">
        <Reactportal
          open={toggle}
          onClose={Closeformfunction}
          TypeOfPortal={"Bulk Notifications"}
          TypeOfId={"Account Id :"}
        >
          {Modal_Key === "EMT_Accounts_Notification" && (
            <p style={{ margin: "0px", padding: "0px", marginLeft: "5px" }}>
              Number Of Accounts : {fielddataRedux?.["Emt_Accounts"]?.Selected_Rows?.length}
            </p>
          )}
          <div className="formContainer">
            {config &&
              config.map((e) => {
                return (
                  <div className="FormSectionParent">
                    <div className="sectionHeadings">{replaceUnderscore(e.name)}</div>
                    <div className="FormSection insidecontainerForThreeSideBySide">
                      <FormInputSectionComponent
                        inputfields={e.fields}
                        Type={e.name}
                        // fielddata={allFieldsData}
                        TypeOfPortal={TypeOfPortal}
                        configData={config}
                        onErrorsChange={handleErrorsChange}
                        onhandleFormikChange={HanldeChangeonForm}
                        formRef={formRef}
                        formkey={Form_Key}
                      />
                    </div>
                  </div>
                );
              })}
          </div>

          <PortalFooter
            renderContent={() => <></>}
            disabled={false}
            // submitform={submit}
            Form_key={Form_Key}
            TypeOfPortal={TypeOfPortal}
            SaveAndClose={() => Validate_handleSubmit(SaveAndClose)}
            handleformclose={() => {
              Closeformfunction();
              setToggle(!toggle);
            }}
            // submitType={"Save"}
            loadingState={loading}
          />
        </Reactportal>
      </div>
    </>
  );
};

export default BulkNotifications;
